(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for one agenda appointment 
    module.directive('agendaDaytaskPinStatus', ['TaskService', 'DateService', 'Alert', function (TaskService, DateService, Alert) {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        function link(scope, element, attrs) {

            var iEl = element.find('i');

            if (scope.vm.task.pinnedToDate === null) {
                iEl.addClass("unpinned");
            } // if

            // pin or unpin
            scope.pinUnpin = function () {
                if (scope.vm.task.pinnedToDate === null) {
                    // pin to selected date
                    TaskService.pin(scope.vm.task.id, DateService.data.date).then(function (result) {
                        Alert.success('Task pinned successfully');
                        // set new date
                        scope.vm.task.pinnedToDate = result.pinnedToDate;
                        // set new reactions
                        scope.vm.task.reactions = result.reactions;

                        // button
                        iEl.removeClass("unpinned");
                    });
                } //if
                else {
                    // unpin to current date
                    TaskService.unpin(scope.vm.task.id).then(function (result) {
                        Alert.success('Task unpinned successfully');
                        // set new date
                        scope.vm.task.pinnedToDate = null;
                        // set new reactions
                        scope.vm.task.reactions = result.reactions;

                        // button
                        iEl.addClass("unpinned");
                    });
                } // else
            };

        }

    }]);

})();